import { z } from "zod";
import { sanitizeInput } from "@/utils/sanitizeInput";
import { UI_TEXT_LOGIN } from "../constants";

export const checklist_login_schema = z.object({
	cpf: z
		.string()
		.transform(sanitizeInput)
		.refine((val) => val.length === 11, UI_TEXT_LOGIN.cpfRequired),

	plate: z
		.string()
		.transform(sanitizeInput)
		.refine((val) => val.length === 7, UI_TEXT_LOGIN.plateRequired),
});
